import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';
import API_BASE_URL from '../config';
import { useNavigate } from 'react-router-dom'; // Add useNavigate

const ClientProposals = () => {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { user } = useContext(AuthContext);
  const navigate = useNavigate(); // Add navigate hook

  useEffect(() => {
    fetchProposals();
  }, [user]);

  const fetchProposals = async () => {
    if (!user?.clientId) return;
    
    try {
      const response = await axios.get(`${API_BASE_URL}/api/proposals?clientId=${user.clientId}&status=published`);
      setProposals(response.data.data);
    } catch (err) {
      setError('Failed to load proposals');
      console.error('Error fetching proposals:', err);
    } finally {
      setLoading(false);
    }
  };

  const updateProposalStatus = async (proposalId, newStatus) => {
    try {
      await axios.put(`${API_BASE_URL}/api/proposals/${proposalId}`, { status: newStatus });
      fetchProposals(); // Refresh the list
    } catch (err) {
      setError('Failed to update proposal');
      console.error('Error updating proposal:', err);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'draft': return '#6c757d';
      case 'published': return '#28a745';
      case 'accepted': return '#007bff';
      case 'rejected': return '#dc3545';
      default: return '#6c757d';
    }
  };

  const handleBack = () => navigate('/'); // Add back function

  if (loading) return <div>Loading your proposals...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div className="App">
      <h1>My Proposals</h1>
      <div className="header-section">
        <button className="back-button" onClick={handleBack}>&lt;</button> {/* Add back button */}
      </div>
      
      {proposals.length === 0 ? (
        <div className="info-box">
          <p>You don't have any published proposals yet.</p>
        </div>
      ) : (
        <div className="trip-list">
          {proposals.map(proposal => (
            <div
              key={proposal._id}
              className="info-box trip-box"
              onClick={() => navigate(`/proposals/${proposal._id}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="trip-title">{proposal.title}</div>
              <div className="trip-details">
                <div className="trip-left">
                  <span>Published: {new Date(proposal.createdAt).toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: 'UTC'
                  })}</span>
                  {proposal.destination && (
                    <span style={{ display: 'block', color: '#666', fontSize: '0.9em', marginTop: '2px' }}>
                      {proposal.destination}
                    </span>
                  )}
                  {proposal.hotels && (
                    <span style={{ display: 'block', color: '#666', fontSize: '0.9em', marginTop: '2px' }}>
                      {proposal.hotels.length} hotel option{proposal.hotels.length !== 1 ? 's' : ''}
                    </span>
                  )}
                </div>
                <div className="trip-right">
                  <span className="trip-dates">
                    {new Date(proposal.startDate).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      timeZone: 'UTC'
                    })}&nbsp;-&nbsp;
                    {new Date(proposal.endDate).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      timeZone: 'UTC'
                    })}
                  </span>
                </div>
              </div>
              <div className="trip-footer">
                {proposal.description && (
                  <p style={{ margin: '10px 0', color: '#555', fontSize: '0.9em' }}>
                    {proposal.description.length > 100
                      ? `${proposal.description.substring(0, 100)}...`
                      : proposal.description}
                  </p>
                )}
                <div style={{
                  marginTop: '15px',
                  fontSize: '0.8em',
                  color: '#666',
                  fontStyle: 'italic'
                }}>
                  Click to view details and manage hotels
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientProposals;
